const onLogout = () => {
    document.cookie = 'student-dashboard-grade= ; expires = Thu, 01 Jan 1970 00:00:00 GMT';
    localStorage.removeItem('passwordConfirmedToken');
    localStorage.removeItem('passwordConfirmedTokenExpiry');

    const logoutRedirectType = sessionStorage.getItem('logoutRedirectType');
    if (logoutRedirectType === 'productPortal') {
        sessionStorage.setItem('postLogoutRedirect', window.config.PRODUCT_SELECTION_URL);
    } else if (logoutRedirectType === 'signin') {
        sessionStorage.setItem('postLogoutRedirect', window.config.SIGNIN_REDIRECT_URL);
    }

    sessionStorage.removeItem('logoutRedirectType');
};

export default onLogout;
